import axios from 'axios';

import { store } from '@store/store';

// Live Make.com curb-side scenario webhook.
const CURB_SIDE_TRIGGER_URL = 'https://hook.us2.make.com/xqihlfyk3d84mfng8e1jwluyghekhl61';

export type CurbSideParams = {
	tripId: number;
};

const notify = ({ tripId }: CurbSideParams) => {
	// The short-lived access token rides in the webhook body (not a header): this call goes
	// straight to Make, not through apiClient, so the interceptor that normally attaches auth
	// doesn't run. Make forwards this token back to fleet-backend on the trip fetch as
	// `Authorization: Bearer <token>` + `Authorization-Type: client`.
	const token = store.getState().auth.token;

	// Skip the call in local dev to save pointless hook invocations. The scenario always runs
	// against production Moovex, so a dev-issued token / trip id won't resolve to a real trip and
	// nothing downstream (iCabbi, SMS) would actually run - there's no real risk either way.
	if (import.meta.env.DEV) {
		// eslint-disable-next-line no-console
		console.warn('Curb-side notify skipped in dev (dummy success, no webhook call)', { tripId });
		return Promise.resolve();
	}
	return axios.post(CURB_SIDE_TRIGGER_URL, { tripId, token });
};

export default {
	notify,
};
